export const app = import.meta.env.VITE_PACKAGE_NAME;
export const ORIGIN_URL = import.meta.env.VITE_ORIGIN_URL;
export const COMPANY_ID = import.meta.env.VITE_COMPANY_ID;

/** 필독사항 헤더 메뉴 경로 (모든 차량 공통 안내 페이지) */
export const MUST_READ_ROUTE = '/must-read';
/** 필독사항 메뉴 강조용 진한 브랜드 컬러 (기본 브랜드 #0091E8보다 진하게) */
export const MUST_READ_COLOR = '#0072B8';

export const CAR_SHEET_COMPANY = {
  name: '꾸러기유모차',
  url: 'https://www.gureogi.com',
  tel: '064-745-9996',
};
